import React from "react";
import { Input } from "../../../../components/form/formik/input/styles";

type FiltersProps = {
  onSubmit: (value: any) => void;
};

export const Filters = ({ onSubmit }: FiltersProps): JSX.Element => {
  const [filter, setFilter] = React.useState<any | undefined>();
  const ref = React.useRef<NodeJS.Timeout | null>(null);

  const handleSubmit = (e: string): void => {
    setFilter((prev: any) => ({ ...prev, query: e }));

    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      onSubmit({ ...filter, query: e, page: 0 });
    }, 500);
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <span>Buscar:</span>
      <Input
        onChange={(e) => {
          handleSubmit(e.target.value);
        }}
        placeholder="Busque por um invoice"
        value={filter?.query}
      />
    </div>
  );
};
